module.exports = __webpack_public_path__ + "static/media/video_market.780f9d64.mp4";